/** ASSUMED height of a Stripes `Button`, which is what the tab bar is made of.
 *  Nothing below sets it; see the module comment. */
var TAB_BUTTON_PX = 32;
/** The bar's vertical padding, applied above and below the buttons. */
var TAB_BAR_PADDING_PX = 8;
/** Expected height of the sticky tab bar, and therefore where content below it
 *  anchors. Only the 16 px of padding is what `tabBarStyle` actually sets; the
 *  other 32 is the assumed button height. */
export var TAB_BAR_STICKY_PX = TAB_BUTTON_PX + 2 * TAB_BAR_PADDING_PX;
/**
 * Sticky tab bar. Keeps the tab switcher in view while the user scrolls a long
 * form (CZNA-72). The solid background prevents scrolled content from bleeding
 * through; the z-index lifts it above the MARC preview panel below.
 */
export var tabBarStyle = {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    background: '#fff',
    paddingTop: "".concat(TAB_BAR_PADDING_PX, "px"),
    paddingBottom: "".concat(TAB_BAR_PADDING_PX, "px"),
    marginBottom: '16px',
    display: 'flex',
    justifyContent: 'center',
};
